<template>
  <span @click="$emit('click')" :is="tag" :to="to" :style="style" :class="[baseCss, 'outline-none', rounded && ratio.replace(':', 'x') !== '4x3' ? 'bcq-flag-rounded' : '', flat ? null : `shadow-${elevation}`]" />
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Flag',
  mixins: [
    props,
    methods
  ],
  props: {
    rounded: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'span'
    },
    to: {
      type: String
    },
    flagsDir: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 3
    },
    flat: {
      type: Boolean
    },
    ratio: {
      type: String,
      default: '1:1',
      validator: value => {
        return ['1:1', '4:3'].includes(value)
      }
    }
  },
  data () {
    return {
      baseCss: this.componentBaseCss('flag', ['select-none', 'inline-block', 'align-middle'])
    }
  },
  computed: {
    url () {
      return `${this.flagsDir}/${this.ratio.replace(':', 'x')}/${this.code.toLowerCase()}.svg`
    },
    style () {
      const size = this.size
      return {
        width: this.ratio.replace(':', 'x') === '4x3' ? `${size}.33333333em` : `${size}em`,
        height: `${size}em`,
        backgroundImage: `url(${this.url})`
      }
    }
  }
}
</script>
<style>
.bcq-flag
{
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.bcq-flag.bcq-flag-rounded
{
  border-radius: 100%;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/flag/flag.vue